import { usePayTokenPriceLatest } from '@ui/features/Trade/hooks/usePayTokenPriceLatest';
import { usePriceLatest } from '@ui/hooks/price/usePriceLatest';
import { usePriceLive } from '@ui/hooks/price/usePriceLive';
import { Position } from '@ui/services/contract/hooks/TradingReaderFacet/useGetPositionV2/types';
import { getLeverage } from '@ui/utils/trade/getLeverage';

import { useDepositCollateralInput } from './useDepositCollateralInput';

export const useLeverageChange = ({ position }: { position: Position }) => {
  const price = usePayTokenPriceLatest(position.collateralToken);
  const { input } = useDepositCollateralInput();
  const pairPrice = usePriceLive(position.pair.baseSymbol);
  if (!price || !pairPrice) return undefined;
  const collateralUsd = position.getCollateralUsd(price);
  const nextCollateralUsd = collateralUsd.plus(input.value.usd ?? 0);

  return {
    prev: position.getLeverage({
      collateralTokenMarketPrice: price,
    }),

    next: getLeverage({
      collateralUsd: nextCollateralUsd,
      sizeUsd: position.size.times(position.entryPrice),
    }),
  };
};

export const useLeverageChangeLatestPrice = ({
  position,
}: {
  position: Position;
}) => {
  const price = usePayTokenPriceLatest(position.collateralToken);
  const { input } = useDepositCollateralInput();
  const pairPrice = usePriceLatest(position.pair.baseSymbol);
  if (!price || !pairPrice) return undefined;
  const collateralUsd = position.getCollateralUsd(price);
  const nextCollateralUsd = collateralUsd.plus(input.value.usd ?? 0);

  return {
    prev: position.getLeverage({
      collateralTokenMarketPrice: price,
    }),

    next: getLeverage({
      collateralUsd: nextCollateralUsd,
      sizeUsd: position.size.times(position.entryPrice),
    }),
  };
};
